// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__Gz2eD","title":"Modal_title__75o5m"};